import { Link } from "react-router-dom";
import AdSlot from "@/components/AdSlot";
import { SiteLogo } from "@/components/Logo";
import { SocialLinks } from "@/components/SocialLinks";

const SKYLINE_IMG = "https://images.unsplash.com/photo-1580536793208-117fdb20ffc1?fm=jpg&q=80&w=2400&auto=format&fit=crop";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-bline bg-surface/40" data-testid="site-footer">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-80" aria-hidden="true">
        <img
          src={SKYLINE_IMG}
          alt=""
          className="h-full w-full object-cover opacity-35"
          style={{
            objectPosition: "50% 30%",
            maskImage: "linear-gradient(to top, black 25%, transparent 100%)",
            WebkitMaskImage: "linear-gradient(to top, black 25%, transparent 100%)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-transparent via-ink/40 to-ink" />
      </div>
      <div className="relative py-10">
        <AdSlot slot="home" label="SPONSORED" />
      </div>
      <div className="relative mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 border-t border-bline px-4 py-10 sm:flex-row sm:px-8 lg:px-12">
        <div>
          <div className="flex items-center gap-3">
            <SiteLogo className="h-10 w-10" />
            <p className="font-display text-2xl tracking-wide text-white">
              SPORTSGEAR<span className="text-volt">DFW</span>
            </p>
          </div>
          <p className="mt-1 text-sm text-slate-500">The metroplex scoreboard. Pro, semi-pro and college — all 31 squads, one wire.</p>
          <p className="mb-2 mt-5 font-score text-[10px] tracking-[0.3em] text-slate-500">FOLLOW THE METROPLEX</p>
          <SocialLinks />
        </div>
        <div className="flex gap-6 font-score text-xs tracking-widest text-slate-500">
          <a href="/#scoreboards" className="transition-colors hover:text-volt">SCORES</a>
          <a href="/#odds" className="transition-colors hover:text-volt">ODDS</a>
          <Link to="/calendar" className="transition-colors hover:text-volt">CALENDAR</Link>
          <Link to="/advertise" className="transition-colors hover:text-volt">ADVERTISE</Link>
          <Link to="/admin" className="transition-colors hover:text-volt">ADMIN</Link>
        </div>
      </div>
      <div className="relative border-t border-bline py-4 text-center font-score text-[10px] tracking-widest text-slate-600">
        © {new Date().getFullYear()} SPORTSGEARDFW · SCORE DATA VIA PUBLIC FEEDS · ODDS FOR INFORMATION ONLY
      </div>
    </footer>
  );
}
